export default __webpack_public_path__ + "static/media/Group_11644.5affb508.svg";